<template>
  <div style="padding-top: env(safe-area-inset-top)">
    <slot />
  </div>
</template>
